import { gql } from "@apollo/client";
import { Location as LocationEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import LocationModel from "../../data/model/Location";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { PaginatedListMetaNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { pageQuery } from "../page-query";

const locationsQuery = gql`
  ${PaginatedListMetaNoNestingFragment}
query GetLocations(${listVariables}) {
    locations(${listOptions}) {
        items {
            id
            name
            enabled
            retailerLocationKey
            updatedAt
            createdAt
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const locationDefinition = new EntityResourceDefinition<
  LocationEntity,
  LocationModel
>({
  entity: "locations",
  query: locationsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity.name || "";
    newEntity.retailerLocationKey = fetchedEntity.retailerLocationKey;
    newEntity.enabled = fetchedEntity.enabled;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "locations", locationsQuery, options);
  },
});
